export const subnetNames: Record<number, string> = {
  0: "Root",
  1: "Apex",
  2: "Omron",
  3: "Templar",
  4: "Targon",
  5: "Open Kaito",
  6: "Infinite Games",
  7: "Subvortex",
  8: "Proprietary Trading Network",
  9: "Iota",
  10: "Sturdy",
  11: "Dippy Roleplay",
  12: "Horde",
  13: "Data Universe",
  14: "TaoHash",
  15: "De-Val",
  16: "HashTensor",
  17: "404-Gen",
  18: "Zeus",
  19: "Nineteen",
  20: "BitAgent",
  21: "Omega Any-to-any",
  22: "Desearch",
  23: "Nuance",
  24: "Omega",
  25: "Mainframe",
  26: "Storb",
  27: "NI Compute",
  28: "LOL",
  29: "Coldint",
  30: "Bettensor",
  31: "CANDLES",
  32: "It's AI",
  33: "ReadyAI",
  34: "BitMind",
  35: "LogicNet",
  36: "Web Agents - Autoppia",
  37: "Finetuning",
  38: "Distributed Training",
  39: "EdgeMaxxing",
  40: "Unknown",
  41: "Sportstensor",
  42: "Real-Time Data",
  43: "Graphite",
  44: "Score",
  45: "SWE",
  46: "Neural3D",
  47: "Unknown",
  48: "Nextplace AI",
  49: "Polaris",
  50: "Synth",
  51: "Celium",
  52: "Dojo",
  53: "Efficient Frontier",
  54: "Yanez MIID",
  55: "Precog",
  56: "Gradients",
  57: "Gaia",
  58: "Dippy Speech",
  59: "Agent Arena",
  60: "Bitsec",
  61: "Red Team",
  62: "Ridges AI",
  63: "Quantum",
  64: "Chutes",
  65: "TAO Private Network",
  66: "FakeNews",
  67: "Unknown",
  68: "Nova",
  69: "Unknown",
  70: "Vericore",
  71: "Unknown",
  72: "StreetVision By NATIX",
  73: "MetaHash",
  74: "Unknown",
  75: "Hippius",
  76: "Safe Scan",
  77: "Liquidity",
  78: "Unknown",
  79: "Taos",
  80: "AI Factory",
  81: "Patrol",
  82: "Unknown",
  83: "Unknown",
  84: "Docs-Insight (Tatsu)",
  85: "Vidaio",
  86: "Unknown",
  87: "CheckerChain",
  88: "Staking",
  89: "Unknown",
  90: "Brain",
  91: "Tensorprox",
  92: "Unknown",
  93: "Bitcast",
  94: "Eastworld",
  95: "Unknown"
};